module.exports = __webpack_public_path__ + "static/key-lightmatter-cee493e20212e3ba6b5469caeb785bb9.webp";